import * as types from "./types";
import * as RoyaltyActionTypes from "../types";

import {
  JSON_STRING,
  HttpClient,
  MHTTPCL
} from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { ContractsService } from "../../services/contracts.service";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import router from "../../../../router";
import { AccountsService } from "../../services/accounts.service";

const NavTabModule = getNavTabModule(
  types.ContractsDetails,
  "contractsDetails"
);

export const RoyaltyContractNavTabModule = NavTabModule;

// Action Object for ContractsRoyalty. Import the types from contracts/types.js and Invoke Actions from the Vuex Host Components.

export const contractsRoyaltyActions = {
  async [types.ContractsRoyaltyData.FETCH.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    const contractsRoyaltyData = await HttpClient.mergeRequests([]);
    commit(types.ContractsRoyaltyData.SET.ALL, contractsRoyaltyData);
  },
  async [types.ContractsList.FETCH.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;
    console.log({ 'actions.js:33 payload': payload });

    let res;

    if (searchMode == "none") {
      if (start == 0) {
        res = await ContractsService.fetchContracts();
        commit(types.ContractsList.SET.ALL, res.data);
      } else {
        const { searchString } = basicFilter;
        res = await ContractsService.getScrollContracts(searchString, start);
        commit(types.ContractsList.SET.ALL, {
          ...getters.contractsList,
          contracts: [
            ...getters.contractsList?.contracts,
            ...res.data.contracts
          ]
        });

        // Setting EOL
        if (!(res?.data?.contracts?.length > 0)) {
          return EOL_REACHED;
        }
      }
    }
    else if (searchMode == "basic") {
      const { searchString } = basicFilter;

      res = await ContractsService.searchContracts(searchString);

      if (start == 0) {
        commit(types.ContractsList.SET.ALL, {
          ...getters.contractsList,
          contracts: res.data.contracts
        });
      }
      else {
        res = await ContractsService.getScrollContracts(searchString, start);
        commit(types.ContractsList.SET.ALL, {
          ...getters.contractsList,
          contracts: [...getters.contractsList.contracts, ...res.data.contracts]
        });
      }

      // Setting EOL
      if (!(res?.data?.contracts?.length > 0)) {
        return EOL_REACHED;
      }
    }
  },
  async [types.ContractsList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { itemID, colorPropertyName, colorPropertyValue, colorValue, colorName } = payload;
    console.log({ itemID, colorPropertyName, colorPropertyValue, colorValue, colorName })

    const mod = await MHTTPCL.modifyJSON(undefined, itemID, colorPropertyName, colorPropertyValue, 'l_contracts');
    console.log("GETTERS", getters, "GETTERS")
    if (getters.contractsDetails && getters.contractsDetails != null && getters.contractsDetails[itemID] != undefined) {
      NavTabHelper.updateSingleNavTabDetails(itemID, contractDetailsObj => {
        return {
          contract: {
            ...contractDetailsObj.contract,
            [colorName]: colorValue,
            [colorPropertyName]: colorPropertyValue
          }
        };
      });
    }


    commit(types.ContractsList.SET.ALL, {
      ...getters.contractsList,
      contracts: getters.contractsList.contracts.map(e => {
        if (e.contract_id == itemID) {
          console.log('::::::::::::OIOIOI')
          return {
            ...e,
            [colorName]: colorValue,
            [colorPropertyName]: colorPropertyValue
          }
        }

        return { ...e }
      }),

    });


  },

  // Show Sidewindow
  async [types.ContractsDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, contract, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "contract_id";
    const itemName = "contract";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "contractsDetails";
    const DetailsAction = types.ContractsDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      ContractsService.fetchContractDetailsTabInfo(contract.contract_id),
      // ContractsService.fetchContractDetailsTabSetup(contract.contract_id),
      ContractsService.fetchDetailsTabContractsItem(contract.contract_id),
      ContractsService.fetchDetailsTabRoyaltyRatesMechanical(
        contract.contract_id
      ),
      // ContractsService.fetchDetailsTabGetContracts(contract.contract_id),
      ContractsService.fetchDetailsTabRoyaltyRates(contract.contract_id),
      ContractsService.fetchDetailsTabTurnoverScale(contract.contract_id),
      ContractsService.fetchDetailsTabLicencingNr(contract.contract_id),
      ContractsService.fetchDetailsTabRecoupables(contract.contract_id),
      ContractsService.fetchDetailsTabRecoupablesMechanical(
        contract.contract_id
      ),
      // ContractsService.fetchDetailsTabAdvances(contract.contract_id),
      // ContractsService.fetchDetailsTabAdvancesAutoBalances(
      //   contract.contract_id,
      //   contract.types
      // ),

      ContractsService.fetchDetailsTabBalances(contract.contract_id, "1,2,3,4"),

      // ContractsService.fetchDetailsTabAutoBalances(
      //   contract.contract_id,
      //   contract.types,
      //   contract.types_not
      // ),
      ContractsService.fetchDetailsTabHistory(contract.contract_id),
      ContractsService.fetchDetailsTabSpecial(contract.contract_id),

      ContractsService.fetchContractDeductionsTab(contract.contract_id),
      ContractsService.fetchContractDeductionsBoxData(contract.contract_id),
      ContractsService.fetchContractDeductionsBoxData(contract.contract_id),


    ]);
    const detailsData2 = await HttpClient.mergeRequests([
      ContractsService.fetchContractDeductionsBoxData(contract.contract_id, 'deduction4'),
    ]);
    const detailsData3 = await HttpClient.mergeRequests([
      ContractsService.fetchContractDeductionsBoxData(contract.contract_id, 'deduction5'),
    ]);

    const pk = detailsData?.contract?.royalty_account_id|| ""

    const detailsData4 =await HttpClient.mergeRequests([  AccountsService.get_royalty_account_contracts(pk)]);

    const contractID = [...detailsData4.contracts.map(x=>{
      return x.contract_id
    })]



    const deductionsDetailsData = {
      deductions4: detailsData2.deductions,
      deductions5: detailsData3.deductions,
      contractDeduction: detailsData2.contract
    }
    console.log(contractID,"detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, contract) => {
        return {
          ...contract,
          ...detailsData,
          ...deductionsDetailsData,
          contractID:[...contractID],
          loading: false
        };
      }
    );
  },

  // Left NavItem child details
  ...NavTabModule.implementActions(
    "contract_id",
    "contracts/contract_id/tab",
    "contracts",
    () => router,
    "royalty",
    (value, key) => {
      const { contracts } = value;

      return {
        title:
          value && value.contract && value.contract.contract_name
            ? value.contract.contract_name
            : key,
        full_title:
          value && value.contract && value.contract.contract_name
            ? value.contract.contract_name
            : key
      };
    }
  ),

  // Action of Updating single Object
  async [types.ContractsDetails.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, selectedContractDetails } = payload;
    console.log({ 'actions.js:257 payload': payload });
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const updateName = name === "template_name" ? "json_data" : name;
    const updateValue = name === "template_name" ? JSON.stringify({ template_name: value }) : value;
    let label_statuses;
    console.log({'actions.js:264 updateName' : updateName, updateValue});

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      label_statuses = contractDetailsObj?.label_statuses;

      return {
        contract: {
          ...contractDetailsObj.contract,
          [updateName]: updateValue
        }
      };
    });


    // If Label Status is not available in the Contract Details
    // Then Fetch it from the Contracts List
    if (!label_statuses) {
      label_statuses = getters?.contractsList?.label_statuses || [];
    }
    

    console.log({ 'actions.js:271 updateName': updateName, updateValue });
    // Update the Contract List as Well

    commit(types.ContractsList.SET.ALL, {
      ...getters.contractsList,
      contracts: getters.contractsList.contracts.map(e => {
        if (e.contract_id === contract_id) {
          return {
            ...e,
            [updateName]: updateValue
          };
        }
        return e;
      })
    });



    const table = "l_contracts";
    if (name === 'template_name') {
      await ContractsService.saveTemplate({ contract_id, template_name: value });
    }
    else {
      const updatedContractDetailsRes = await MHTTPCL.modifyJSON(
        undefined,
        contract_id,
        name,
        value,
        table
      );


      // After Updating the Database -> Update the Contracts within Royalty Account
      // contract_name	"Bobby Zieme "
      // royalty_types	"physical, digital, licensing, thirdparty"
      // contract_id	315
      // label_status_name	"Artist"
      // catalog_nos_comma	null
      // royalties	"Active"
      // cross_collectable	1
      // label_status_colour	"3F9E7E"

      if ([
        "contract_name",
        "royalty_types",
        "contract_id",
        "label_status_name",
        "catalog_nos_comma",
        "royalties",
        "cross_collectable",
        "label_status_colour",
        "label_status_id",
      ].includes(name)) {
        const nvps = name === 'label_status_id' ? [
          ["label_status_colour", label_statuses?.find(e => `${e.label_status_id}` === `${value}`).label_status_colour],
          ["label_status_name", label_statuses?.find(e => `${e.label_status_id}` === `${value}`).label_status_name],
        ] : [];

        console.log({'actions.js:347 nvps' : nvps});

        dispatch(RoyaltyActionTypes.AccountsDetails.UPDATE.SINGLE, {
          selectedAccountDetails: {
            account: {
              royalty_account_id: contract.royalty_account_id
            }
          },
          path: "contracts",
          name,
          value,
          nvps,
          primaryKey: "contract_id",
          kVal: contract_id,
          noDatabaseUpdate: true,
        })
      }
    }
  },

  // Related Files
  async [types.SET_CONTRACT_PRODUCT_FILES](
    { dispatch, getters },
    { files, externalId, externalTable }
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const contract_id = externalId;
    NavTabHelper.setSingleNavTabDetails(
      contract_id,
      (_, contractDetailsObj) => {
        return {
          ...contractDetailsObj,
          files
        };
      }
    );
  },

  // Start Action of Updating single Object -- Tracks
  async [types.ContractTrack.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "contract_pos_id";
    const kVal = item[key];
    const table = "l_contract_pos";

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        tracks: contractDetailsObj.tracks.map(e => {
          if (e.contract_pos_id == item.contract_pos_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedTrack = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },
  // End Tracks Update

  // Start Products Update
  async [types.ContractProduct.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "contract_pos_id";
    const kVal = item[key];
    const table = "l_contract_pos";

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        products: contractDetailsObj.products.map(e => {
          if (e.contract_pos_id == item.contract_pos_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedProduct = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },
  // End Products Update

  // Start Releases Update
  async [types.ContractRelease.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "contract_pos_id";
    const kVal = item[key];
    const table = "l_contract_pos";

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        releases: contractDetailsObj.releases.map(e => {
          if (e.contract_pos_id == item.contract_pos_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedRelease = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },
  // End Releases Update

  // Releases Delete
  async [types.ContractItems.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("show Items name? ", payload);
    const { channel, contract_id, contract_pos_id } = payload;
    const channelKey = `${channel}`; // Template string

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        [channel]: contractDetailsObj[channel].filter(
          e => e.contract_pos_id != contract_pos_id
        )
      };
    });
    await ContractsService.deleteContractItems(contract_pos_id);
  },

  async [types.ContractItems.DELETE.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("show Items name? ", payload);
    const { channel, contract_id } = payload;
    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        [channel]: []
      };
    });

    if(channel=='tracks'){
      await ContractsService.removeContractTracks({contract_id});
    }
    else if(channel=='products'){
      await ContractsService.removeContractProducts({contract_id});
    }
    else{
      await ContractsService.removeContractReleases({contract_id});
    }
    
  },

  // Start Releases SearchList - Setup
  async [types.ContractRelease.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { releases, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        releases
      };
    });
  },
  async [types.ContractsFlagDetails.SET.ALL]({ commit, getters, dispatch }, payload) {
    const { display_contract_deductions_subtab, display_auto_balance_subtab } = payload;
    commit(types.ContractsFlagDetails.SET.ALL, {
      display_contract_deductions_subtab,
      display_auto_balance_subtab
    });

  },
  async [types.AutoFillRelease.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { products, tracks, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        ...contractDetailsObj,
        products,
        tracks
      };
    });
  },

  async [types.AutoFillTrack.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { releases, products, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        ...contractDetailsObj,
        releases,
        products
      };
    });
  },

  async [types.ContractTrack.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { tracks, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        tracks
      };
    });
  },
  async [types.ContractDeductions.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { deductions_target, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;
    if (deductions_target == 'deduction4') {
      const res = await ContractsService.fetchContractDeductionsBoxData(contract_id, 'deduction4')
      const deductions4 = res.data.deductions;
      NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
        return {
          deductions4: deductions4
        };
      });
    }
    else {
      const res = await ContractsService.fetchContractDeductionsBoxData(contract_id, 'deduction5')
      const deductions5 = res.data.deductions;
      NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
        return {
          deductions5: deductions5
        };
      });
    }


  },
  async [types.ContractDeductions.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { deductions_target, contract_deduction_id, selectedContractDetails } = payload;
    let { contract, deductions4, deductions5 } = selectedContractDetails;
    const { contract_id } = contract;
    const res = await ContractsService.deleteContractDeduction(contract_deduction_id);
    if (deductions_target == 'deduction4') {
      deductions4 = deductions4.filter(d => d.contract_deduction_id !== contract_deduction_id);
      NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
        return {
          deductions4: deductions4
        };
      });
    }
    else {
      deductions5 = deductions5.filter(d => d.contract_deduction_id !== contract_deduction_id);
      NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
        return {
          deductions5: deductions5
        };
      });
    }


  },

  async [types.ContractProduct.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { products, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        products
      };
    });
  },

  // Start Action of Updating single Object -- Royalty Rates
  async [types.ContractRoyaltyRates.UPDATE.SINGLE](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const {
      channel,
      name,
      value,
      item,
      modalEdit,
      saveRoyaltyOption,
      selectedContractDetails
    } = payload;

    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "royalty_option_id";
    const kVal = item[key];
    const table = "l_royalty_options";

    const channelKey = `${channel}_royalty_options`; // Template string

    if (modalEdit) {

      let res;
      if (channel == "physical") {
        res = await ContractsService.savePhysicalRoyalty(saveRoyaltyOption);
      } else if (channel == "digital") {
        res = await ContractsService.saveDigitalRoyalty(saveRoyaltyOption);
      }
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: res.data.royalty_options
          };
        }
      );
    }

    else {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: contractDetailsObj[channelKey].map(e => {
              if (e.royalty_option_id == item.royalty_option_id) {
                return {
                  ...e,
                  [name]: value
                };
              } else {
                return e;
              }
            })
          };
        }
      );

      const modifiedRoyaltyRates = await MHTTPCL.modifyJSON(
        undefined,
        kVal,
        name,
        value,
        table
      );
    }
  },

  async [types.ContractRoyaltyRates.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { channel, royalty_options, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;
    const channelKey = `${channel}_royalty_options`; // Template string

    if (channel) {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            ...contractDetailsObj[channelKey],
            [channelKey]: royalty_options
          };
        }
      );
    }
  },

  async [types.ContractRoyaltyRates.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { royalty_option_id, channel, contract_id } = payload;
    const channelKey = `${channel}_royalty_options`; // Template string

    if (channel) {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: contractDetailsObj[channelKey].filter(
              e => e.royalty_option_id != royalty_option_id
            )
          };
        }
      );
    }
    await ContractsService.deleteRoyaltyRate(royalty_option_id);
  },

  async [types.ContractRoyaltyRatesReserve.SET.ALL](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { reserve_settings, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        reserve_settings
      };
    });
  },

  async [types.ContractlReserveSettings.SET.ALL](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { reserve_settings, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        reserve_settings
      };
    });
  },

  // Start Action of Updating single Object -- Reserve Setup (based on mechanical flag)
  async [types.ContractlReserveSettings.UPDATE.SINGLE](
    { getters, dispatch },
    payload
  ) {
    console.log("ContractlReserveSettings.UPDATE.SINGLE actions ", payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "reserve_setting_id";
    const kVal = item[key];
    const table = "l_reserve_settings";

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        reserve_settings: contractDetailsObj.reserve_settings.map(e => {
          if (e.reserve_setting_id == item.reserve_setting_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedReserveSetup = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  async [types.ContractlReserveSettings.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    console.log("ContractlReserveSettings actions ", payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { reserve_setting_id, contract_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        reserve_settings: contractDetailsObj.reserve_settings.filter(
          e => e.reserve_setting_id != reserve_setting_id
        )
      };
    });
    await ContractsService.deleteReverseSetup(contract_id, reserve_setting_id);
  },

  async [types.RecoupableContractBalances.SET.ALL](
    { dispatch, getters },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("RecoupableContractBalances actions ", payload);

    const { channel, balances, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    if (channel == "carried_over") {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            balances_34: balances
          };
        }
      );
    } else {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            balances_12: balances
          };
        }
      );
    }
  },

  // Action of Updating single Object
  async [types.RecoupableContractBalances.UPDATE.SINGLE](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("RecoupableContractBalances.UPDATE.SINGLE actions ", payload);
    const { channel, name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "balance_id";
    const kVal = item[key];
    const table = "l_balances";

    if (channel == "carried_over") {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            balances_34: contractDetailsObj.balances_34.map(e => {
              if (e.balance_id == item.balance_id) {
                return {
                  ...e,
                  [name]: value
                };
              } else {
                return e;
              }
            })
          };
        }
      );
    } else if (channel == "recoupables") {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            balances_12: contractDetailsObj.balances_12.map(e => {
              if (e.balance_id == item.balance_id) {
                return {
                  ...e,
                  [name]: value
                };
              } else {
                return e;
              }
            })
          };
        }
      );
    }

    const modifiedContractBalances = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  async [types.RecoupableContractBalances.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    console.log("RecoupableContractBalances actions ", payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { channel, balance_id, contract_id } = payload;

    if (channel == "carried_over") {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            balances_34: contractDetailsObj.balances_34.filter(
              e => e.balance_id != balance_id
            )
          };
        }
      );
    } else if (channel == "recoupables") {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            balances_12: contractDetailsObj.balances_12.filter(
              e => e.balance_id != balance_id
            )
          };
        }
      );
    }

    await ContractsService.deleteBalance(balance_id);
  },

  // Start Action of Updating single Object -- Reserve Setup
  async [types.ContractRoyaltyRatesReserve.UPDATE.SINGLE](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "reserve_setting_id";
    const kVal = item[key];
    const table = "l_reserve_settings";

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        reserve_settings: contractDetailsObj.reserve_settings.map(e => {
          if (e.reserve_setting_id == item.reserve_setting_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedReserveSetup = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  async [types.ContractRoyaltyRatesReserve.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { reserve_setting_id, contract_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        reserve_settings: contractDetailsObj.reserve_settings.filter(
          e => e.reserve_setting_id != reserve_setting_id
        )
      };
    });
    await ContractsService.deleteReverseSetup(contract_id, reserve_setting_id);
  },

  async [types.ContractLicencingNr.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { channel, royalty_options, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;
    const channelKey = `${channel}_royalty_options`;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        ...contractDetailsObj[channelKey],
        [channelKey]: royalty_options
      };
    });
  },

  async [types.ContractLicencingNr.UPDATE.SINGLE](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const {
      channel,
      name,
      value,
      item,
      selectedContractDetails,
      saveRoyaltyOptionFlag,
      saveRoyaltyOption
    } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const channelKey = `${channel}_royalty_options`; // Template string

    const key = "royalty_option_id";
    const kVal = item[key];
    const table = "l_royalty_options";

    if (saveRoyaltyOptionFlag) {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: contractDetailsObj[channelKey].map(e => {
              if (e.royalty_option_id == item.royalty_option_id) {
                return {
                  ...e,
                  ...saveRoyaltyOption
                };
              } else {
                return e;
              }
            })
          };
        }
      );

      if (channel == "performance") {
        await ContractsService.savePerformanceLicencingNr(saveRoyaltyOption);
      } else if (channel == "thirdparty") {
        await ContractsService.saveThirdpartyLicencingNr(saveRoyaltyOption);
      }
    } else {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: contractDetailsObj[channelKey].map(e => {
              if (e.royalty_option_id == item.royalty_option_id) {
                return {
                  ...e,
                  [name]: value
                };
              } else {
                return e;
              }
            })
          };
        }
      );
    }

    const modifiedReserveSetup = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  async [types.ContractLicencingNr.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { royalty_option_id, channel, contract_id } = payload;
    const channelKey = `${channel}_royalty_options`; // Template string

    if (channel) {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: contractDetailsObj[channelKey].filter(
              e => e.royalty_option_id != royalty_option_id
            )
          };
        }
      );
    }
    await ContractsService.deleteRoyaltyRate(royalty_option_id);
  },

  // Turnover Add
  async [types.TurnoverScale.INSERT.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { contract_id } = payload;
    const res = await ContractsService.submitRoyaltyScales(payload);
    const tScale = await ContractsService.fetchTurnoverScale(contract_id);

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        royalty_scales: res.data.royalty_scales,
        turnover_scale: tScale.data.turnover_scale
      };
    });
  },

  // Turnover Inline table & Modal update
  async [types.TurnoverScale.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { turnover_scale, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    // if modal edit true
    const royalty_scalesRes = await ContractsService.submitRoyaltyScales(
      turnover_scale
    );
    const turnover_scaleRes = await ContractsService.fetchTurnoverScale(
      contract_id
    );

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        royalty_scales: royalty_scalesRes.data.royalty_scales,
        turnover_scale: turnover_scaleRes.data.turnover_scale
      };
    });
  },

  // Quantity Scale -- Add
  async [types.ContractRoyaltyScale.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { royalty_scales, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        // ...contractDetailsObj.royalty_scales,
        royalty_scales
      };
    });
  },

  // Quantity Scale -- Inline table & Modal update
  async [types.ContractRoyaltyScale.UPDATE.SINGLE](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const {
      name,
      value,
      item,
      modalEdit,
      saveRoyaltyScale,
      selectedContractDetails
    } = payload;

    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "royalty_scale_id";
    const kVal = item[key];
    const table = "l_royalty_scales";

    if (modalEdit) {
      // if modal edit true
      const quantityRes = await ContractsService.saveQtyScale(saveRoyaltyScale);

      const turnover_scaleRes = await ContractsService.fetchTurnoverScale(
        contract_id
      );

      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            royalty_scales: quantityRes.data.royalty_scales,
            turnover_scale: turnover_scaleRes.data.turnover_scale
          };
        }
      );
    } else {
      // inline edit - table
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            royalty_scales: contractDetailsObj.royalty_scales.map(e => {
              if (e.royalty_scale_id == item.royalty_scale_id) {
                return {
                  ...e,
                  [name]: value
                };
              } else {
                return e;
              }
            })
          };
        }
      );

      // inline edit - table
      const modifiedScales = await MHTTPCL.modifyJSON(
        undefined,
        kVal,
        name,
        value,
        table
      );
    }
  },

  async [types.ContractRoyaltyScale.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { royalty_scale_id, contract_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        royalty_scales: contractDetailsObj.royalty_scales.filter(
          e => e.royalty_scale_id != royalty_scale_id
        )
      };
    });

    await ContractsService.deleteRoyaltyScale(royalty_scale_id);
  },

  async [types.TurnoverScale.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { royalty_scale_id, contract_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        turnover_scale: null
      };
    });

    await ContractsService.deleteRoyaltyScale(royalty_scale_id);
  },

  // End Royalty Rates

  // Action of Updating single Object - Recoupables
  async [types.RoyaltyCostGroups.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { channel, name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    if (channel == "status") {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            contract: {
              ...contractDetailsObj.contract,
              [name]: value
            }
          };
        }
      );
      const table = "l_contracts";

      const updatedContractDetailsRes = await MHTTPCL.modifyJSON(
        undefined,
        contract_id,
        name,
        value,
        table
      );
    } else {
      const key = "royalty_cost_group_id";
      const kVal = item[key];
      const table = "l_royalty_cost_groups";
      const channelKey = `royalty_${channel}_groups`; // Template string

      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: contractDetailsObj[channelKey].map(e => {
              if (e.royalty_cost_group_id == item.royalty_cost_group_id) {
                return {
                  ...e,
                  [name]: value
                };
              } else {
                return e;
              }
            })
          };
        }
      );

      const modifiedLabel = await MHTTPCL.modifyJSON(
        undefined,
        kVal,
        name,
        value,
        table
      );
    }
  },

  async [types.RoyaltyCostGroups.INSERT.SINGLE](
    { dispatch, getters },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { channel, royalty_cost_groups, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;
    const channelKey = `royalty_${channel}_groups`; // Template string  royalty_cost_groups

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        ...contractDetailsObj[channelKey],
        [channelKey]: [
          ...contractDetailsObj[channelKey],
          ...royalty_cost_groups
        ]
      };
    });
  },

  /**
   * let a = [2,3,4]; Array<Number>
   * let b = 1; Number
   *
   * Make c Array insert b into a
   * let c = [...a, b]
   * Make c Array append b before a
   * let c = [b, ...a]
   * Make c Array concat a with Empty Array
   * let c = [...a, ...(newArray || [])]
   *
   * concat = add
   * insert/append Container<DataType> => DataType
   *
   */

  async [types.RoyaltyCostGroups.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { royalty_cost_group_id, channel, contract_id } = payload;

    const channelKey = `royalty_${channel}_groups`; // Template string

    if (channel) {
      NavTabHelper.updateSingleNavTabDetails(
        contract_id,
        contractDetailsObj => {
          return {
            [channelKey]: contractDetailsObj[channelKey].filter(
              e => e.royalty_cost_group_id != royalty_cost_group_id
            )
          };
        }
      );
    }
    await ContractsService.deleteRecoupables(royalty_cost_group_id);
  },

  // Start Specials
  async [types.ContractSpecials.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { relations, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        relations
      };
    });
  },

  async [types.ContractSpecials.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { relation_id, contract_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        relations: contractDetailsObj.relations.filter(
          e => e.relation_id != relation_id
        )
      };
    });
    await ContractsService.deleteAutoFetch(relation_id);
  },

  // Start Balances
  // Action of Updating single Object
  async [types.ContractBalance.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    const key = "balance_id";
    const kVal = item[key];
    const table = "l_balances";

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        balances: contractDetailsObj.balances.map(e => {
          if (e.balance_id == item.balance_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedBalance = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  async [types.ContractBalance.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { balance_id, contract_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        balances: contractDetailsObj.balances.filter(
          e => e.balance_id != balance_id
        )
      };
    });
    await ContractsService.deleteBalance(balance_id);
  },

  async [types.ContractBalance.SET.ALL]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { balances, selectedContractDetails } = payload;
    const { contract } = selectedContractDetails;
    const { contract_id } = contract;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        balances
      };
    });
  },

  // Action of Updating single Object
  async [types.ContractMC.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, selectedContractDetails } = payload;
    const { contract, mc } = selectedContractDetails;
    const { contract_id } = contract;
    const { l_mechanical_contract_id } = mc;

    NavTabHelper.updateSingleNavTabDetails(contract_id, contractDetailsObj => {
      return {
        mc: {
          ...contractDetailsObj.mc,
          [name]: value
        }
      };
    });

    const table = "l_mechanical_contracts";

    const updatedMechanicalRes = await MHTTPCL.modifyJSON(
      undefined,
      l_mechanical_contract_id,
      name,
      value,
      table
    );
  },

  // Contracts list Details - Delete from tab right
  async [types.ContractTabDelete.DELETE.SINGLE]({ commit, getters }, item) {
    const { contract_id } = item;

    console.log("Show getters data ", getters.contractsList.contracts);
    let newContractList = getters.contractsList.contracts.filter(
      e => e.contract_id != contract_id
    );

    commit(types.ContractsList.SET.ALL, { contracts: newContractList });

    const removeContractsList = await ContractsService.deleteContract(
      contract_id
    );
  }
};
